// extracted by mini-css-extract-plugin
module.exports = {"actionWidth":"18%","userWidth":"15%","dateWidth":"12%","entityTypeWidth":"12%","entityTitleWidth":"13%","changesWidth":"30%"};